module.exports = __webpack_public_path__ + "static/media/troca.b413b34f.svg";